module.exports = __webpack_public_path__ + "assets/img/ifood-light.1dcf648a.svg";